import { XIcon } from 'lucide-react';
import { cn } from '@noor/lib/cn';

export interface FilterClearButtonProps {
  /** Clears this field's value. */
  onClear: () => void;
  'aria-label'?: string;
  className?: string;
}

/**
 * The small "×" that clears a single filter field. Rendered inside a filter
 * control (search input, select trigger, date pill) and shown only when that
 * field has a value. Stops propagation so clicking it clears without also
 * opening the control's popover/dropdown.
 */
export function FilterClearButton({
  onClear,
  className,
  ...aria
}: FilterClearButtonProps) {
  return (
    <button
      type="button"
      aria-label={aria['aria-label'] ?? 'Clear'}
      // `onPointerDown` (not just onClick) so a Radix trigger doesn't open on the
      // press before the clear fires; both are stopped to be safe.
      onPointerDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClear();
      }}
      className={cn(
        'flex size-5 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:ring-[3px] focus-visible:ring-ring/40 focus-visible:outline-none',
        className,
      )}
    >
      <XIcon className="size-3.5" />
    </button>
  );
}
